import { load } from "@cashfreepayments/cashfree-js";
import toast from "react-hot-toast";
import { CASHFREE_MODE } from "../../../config/api.config";
import { msg } from "../messages";

async function fetchData() {
  const cashfree = await load({
    mode: CASHFREE_MODE,
  });
  return cashfree;
}
// Resolves with Cashfree's checkout result once the sheet closes (for
// redirectTarget "_modal"), so a caller can confirm the payment afterwards.
// `silent` skips the toast for callers that report the outcome themselves.
export const cashfreeCheckout = (checkoutOptions, { silent = false } = {}) => {
  return fetchData().then((cashfree) => {
    return cashfree.checkout(checkoutOptions).then(function (result) {
      // Cashfree's own error text is technical; show our one line instead.
      if (result.error && !silent) {
        toast.error(msg("PAYMENT.NOT_COMPLETED"));
      }
      // alert(result)
      if (result.redirect) {
      }
      // Close the current tab
      return result;
    });
  });
};
